module.exports = __webpack_public_path__ + "static/media/21.12489191.mp3";